// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'two-disk-stacks';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M5.04 5.04c2.465 0 4.464-1 4.464-2.232S7.505.576 5.04.576s-4.464 1-4.464 2.232S2.575 5.04 5.04 5.04zm4.536.792V2.808' />
    <path d='M.576 2.808V14.04c0 1.224 2.016 2.232 4.464 2.232.432 0 .864 0 1.296-.072' />
    <path d='M.576 11.232c0 1.224 2.016 2.232 4.464 2.232.432 0 .864 0 1.296-.072M.576 8.424c0 1.224 2.016 2.232 4.464 2.232.432 0 .864 0 1.296-.072M.576 5.616c0 1.224 2.016 2.232 4.464 2.232.432 0 .864 0 1.296-.072m6.624 4.176c2.465 0 4.464-1 4.464-2.232 0-1.233-1.998-2.232-4.464-2.232s-4.464 1-4.464 2.232c0 1.233 1.999 2.232 4.464 2.232z' />
    <path d='M8.424 9.72v5.472c0 1.224 2.016 2.232 4.464 2.232s4.464-1.008 4.464-2.232V9.72' />
    <path d='M17.424 12.384c0 1.224-2.016 2.232-4.464 2.232s-4.464-1.008-4.464-2.232' />
  </g>
);

export const viewBox = '0 0 18 18';
